import { render, staticRenderFns } from "./candidateLog.vue?vue&type=template&id=1ddb1f53&"
import script from "./candidateLog.vue?vue&type=script&lang=js&"
export * from "./candidateLog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports